export const isMobilapp = (): boolean => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("token") !== null;
};
